import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_L, ModuleFE_Notifications, Button } from '@nu-art/thunderstorm-frontend/index';
import './PgDev_Notifications.scss';
class PgDev_Notifications_Class extends ComponentSync {
    deriveStateFromProps(nextProps) {
        return {};
    }
    postNotification = () => {
        const randomNumber = Math.floor(Math.random() * 100 + 1);
        ModuleFE_Notifications.create().content('Test Title', `This is a test ${randomNumber}`).show(3000);
    };
    showAllNotifications = () => {
        ModuleFE_Notifications.showAllNotifications();
    };
    postThreeNotifications = () => {
        for (let i = 0; i < 3; i++) {
            setTimeout(() => {
                this.postNotification();
            }, i * 500);
        }
    };
    render() {
        return _jsxs(LL_V_L, { style: { padding: '20px', gap: '10px' }, children: [_jsx(Button, { onClick: this.postNotification, children: "Post Notification" }), _jsx(Button, { onClick: this.postThreeNotifications, children: "Post 3 Notifications" }), _jsx(Button, { onClick: this.showAllNotifications, children: "Show All Notification" }), _jsx(Button, { onClick: () => this.logInfo('HELLO'), children: "Say Hello" })] });
    }
}
export const PgDev_Notifications = { name: 'Notifications', key: 'notifications', renderer: PgDev_Notifications_Class };
